/**
 * Search option types and utilities.
 * Uses central datasource configuration for consistency.
 */

import { DataSource } from "@/config/datasources";

/**
 * Reverse mapping: DataSource enum value -> enum key name
 * The API expects enum key names, but TypeScript enums use the value at runtime
 */
const enumValueToKey: Record<string, string> = Object.fromEntries(
  Object.entries(DataSource).map(([key, value]) => [value, key])
);

export type SearchOption = {
  type: string;
  filter: string;
};

/**
 * Map DataSource to API string representation
 * The API expects enum key names. They match the enum values for every current
 * source except Arvid, which the API spells "ARVID".
 */
export const mapType = (type: DataSource): string => {
  // Special handling for types where API representation differs from enum key
  switch (type) {
    // Special search option types (not actual datasources)
    case DataSource.Document:
      return "Document";
    case DataSource.ChatGPT:
      return "ChatGPT";
    case DataSource.Workspace:
      return "Workspace";
    
    // Datasources with custom API representations (different from enum key)
    case DataSource.Arvid:
      return "ARVID";
    
    // Default: return the enum key name
    default:
      return enumValueToKey[type] || type;
  }
};
